import React from 'react'
import { Button, DropdownMenu, Flex, useAppTheme } from '@workwhile/ui'
import { EllipsisVertical, EyeOff, Pencil, RotateCcw } from 'lucide-react'
import { createGlobalStyle } from 'styled-components'
import { CompumaticPunch } from 'api/admin/timeClock/listCompumaticPunches'
import { useCompumaticClockPunchesContextValue } from '../context/CompumaticClockPunchesProvider'
import { useCompumaticClockPunchesWorkflowsContextValue } from '../context/CompumaticClockPunchesWorkflowsProvider'

const DropdownZIndexFix = createGlobalStyle`
  [data-radix-popper-content-wrapper] {
    z-index: 100 !important;
  }
`

type CompumaticPunchActionsCellProps = {
  punch: CompumaticPunch
}

const stopRowExpand = (event: React.SyntheticEvent) => {
  event.stopPropagation()
}

export const CompumaticPunchActionsCell = ({
  punch,
}: CompumaticPunchActionsCellProps) => {
  const { space } = useAppTheme()
  const {
    editPunchFlow: { open: openEditPunch },
  } = useCompumaticClockPunchesWorkflowsContextValue()
  const {
    actions: { reprocessPunchIds, openIgnoreConfirm },
  } = useCompumaticClockPunchesContextValue()

  return (
    <>
      <DropdownZIndexFix />
      <Flex
        justifyContent="center"
        alignItems="center"
        width="100%"
        onClick={stopRowExpand}
        onKeyDown={stopRowExpand}
      >
        <DropdownMenu
          trigger={
            <Button
              variant="secondary"
              kind="small"
              style={{ paddingLeft: space[1], paddingRight: space[1] }}
              aria-label="Punch actions"
            >
              <EllipsisVertical size={14} />
            </Button>
          }
        >
          <DropdownMenu.Item onClick={() => openEditPunch(punch)}>
            <Flex as="span" alignItems="center" style={{ gap: 8 }}>
              <Pencil size={14} />
              Edit punch
            </Flex>
          </DropdownMenu.Item>
          <DropdownMenu.Item onClick={() => reprocessPunchIds([punch.id])}>
            <Flex as="span" alignItems="center" style={{ gap: 8 }}>
              <RotateCcw size={14} />
              Reprocess punch
            </Flex>
          </DropdownMenu.Item>
          <DropdownMenu.Item onClick={() => openIgnoreConfirm([punch.id])}>
            <Flex as="span" alignItems="center" style={{ gap: 8 }}>
              <EyeOff size={14} />
              Ignore punch
            </Flex>
          </DropdownMenu.Item>
        </DropdownMenu>
      </Flex>
    </>
  )
}
